import React from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", name: "EN", flag: "🇬🇧" },
  { code: "de", name: "DE", flag: "🇩🇪" },
  { code: "fr", name: "FR", flag: "🇫🇷" },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-1 shrink-0">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`inline-flex items-center justify-center h-11 md:h-9 px-2 md:px-2.5 rounded border font-mono text-xs transition ${
            i18n.language === lang.code
              ? "border-amber text-amber"
              : "border-border text-muted hover:text-text hover:border-cyan"
          }`}
        >
          {/* Regional-indicator flags only render as flags on Apple platforms; Windows shows
              bare letter pairs and many Linux builds show tofu. Below md the space is better
              spent on the nav links, so the code alone carries the meaning. */}
          <span className="hidden md:inline mr-1">{lang.flag}</span>
          {lang.name}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
